import React from 'react';
import PropTypes from 'prop-types';
import PaymentSelector from '../PaymentSelector';
import PaymentSelectorOption from '../PaymentSelectorOption';


/**
 * A simple PaymentSelectorGroup.
 */

class PaymentSelectorGroup extends React.Component {
	constructor(props) {
      super(props);
      this.selectGroup = this.selectGroup.bind(this);
      this.selectOption = this.selectOption.bind(this);
      this.state = {
        payment: '',
          paymentOption:0,
          paymentPrice:'',
          paymentRuntime:0,
        isset: false
      };
    }

    componentDidMount() {
      if(this.props.isOnlyPayment) {
        this.selectGroup();
      }
    }

    componentWillUpdate(nextProps, nextState) {
      if(this.props.selected && !nextProps.selected) {
        this.setState({
          payment: '',
          paymentOption:0,
          paymentPrice:'',
          paymentRuntime:0,
          isset: false
        });
      }
    }

    selectOption(type, option, id) {
       var newState = {
        payment:'',
        paymentOption:id,
        paymentPrice:'',
        paymentRuntime:0,
        isset: true
      };
      
       if(type==='purchase') {
        newState.payment = option.type;
        newState.paymentPrice = option.price;
       } else if(type==='payever') {
        newState.payment = this.props.config.type;
        newState.paymentPrice = option.price;
       } else if(type==='financing') {
        newState.payment = this.props.config.type;
        newState.paymentRuntime = option.runtime;
        newState.paymentPrice = option.price;
       }
       this.props.onChangeOption(this.props.config, newState);
      this.setState(newState);
    }

    selectGroup() {
      if (this.props.config.hasOwnProperty('rejected') && this.props.config.rejected) {
        return;
      }
      this.props.onChangeGroup(this.props.config);
    }


    render () {
        const group = this.props.config.group;
      var rejected = false;

      if (this.props.config.hasOwnProperty('rejected')) {
        rejected = this.props.config.rejected;
      }
      const selected = this.props.selected;// || (this.props.isOnlyPayment && !rejected);
      const onlyOption = this.props.config.data.length === 1 && this.props.isOnlyPayment && !rejected;
        return (
          <div className={`paymentselectorgroup${selected ? " selected" : ""}${rejected ?" rejected":""}`}>
              <PaymentSelector choice={this.props.config} selected={selected} onClick={this.selectGroup} />
              <div className="optionswrapper">
            	 <div className="options">
                {
                  this.props.config.data.map((item, n) => <PaymentSelectorOption id={`${this.props.config.id}_${n}`} ref={`paymentselectoritem_${n}`} key={`paymentselectoritem_${n}`} active={selected} type={group} onlyOption={onlyOption} choice={item} onClick={this.selectOption} /> )
                }
                </div>
              </div>
          </div>
        );
    }

}

PaymentSelectorGroup.propTypes = {
	/** configuration object */
	config: PropTypes.object.isRequired,
	/** checkSelected */
	selected: PropTypes.bool,
  isOnlyPayment: PropTypes.bool,
  /** Gets called when the user changes a config */
  onChangeGroup: PropTypes.func,
	/** Gets called when the user changes a option */
	onChangeOption: PropTypes.func
}
PaymentSelectorGroup.defaultProps = {
  isOnlyPayment: false
}



export default PaymentSelectorGroup






// WEBPACK FOOTER //
// ./src/components/molecules/PaymentSelectorGroup/PaymentSelectorGroup.js